export const BOTTOM_NAVIGATION_HEIGHT = 60;
export const FOOTER_HEIGHT = 121;
export const HEADER_HEIGHT = 60;

export const Z_INDEXES = {
  HEADER: 10,
  BOTTOM_NAVIGATION: 10,
  BANK_INPUT: 10,
};
